import React, { ReactNode } from 'react';
import { CoursePricingOption } from '../../../../../../../store/features/coursePricing';
import {
  StyledOptionDisplayCard,
  StyledOptionDisplayFilter,
  StyledOptionDisplayWrapper,
  StyledOptionDisplayCardsList,
} from '../../../styledComponents';

export type OptionDisplayProps = {
  filter?: ReactNode;
  renderOptionCard: (option: CoursePricingOption) => ReactNode;
  options: CoursePricingOption[];
};

export function OptionDisplay(props: OptionDisplayProps) {
  const { filter, renderOptionCard, options } = props;

  return (
    <StyledOptionDisplayWrapper>
      {filter && (
        <StyledOptionDisplayFilter>{filter}</StyledOptionDisplayFilter>
      )}
      <StyledOptionDisplayCardsList>
        {options.map((option, index) => (
          <StyledOptionDisplayCard key={index}>
            {renderOptionCard(option)}
          </StyledOptionDisplayCard>
        ))}
      </StyledOptionDisplayCardsList>
    </StyledOptionDisplayWrapper>
  );
}
